export default __webpack_public_path__ + "static/media/profileWaveBg.bad1bfe4.svg";